import message from 'antd/lib/message';

import { batchActions } from 'redux-batched-actions';

import * as api from '../../api/apiko-api';
import { getResErrorMsg } from '../../utils';
import * as actions from '../actions/comments';
import * as requestsActions from '../actions/requests';
import * as companiesActions from '../actions/companies';


/**
 * handleCommentCreate :: Object -> Func -> Promise Error _
 */
export const handleCommentCreate = data => dispatch =>
  Promise.resolve(dispatch(actions.createCommentRequest()))
    .then(() => api.createComment(data))
    .then(({ comment }) => {
      message.success('Comment created');
      return dispatch(batchActions([
        actions.createCommentSuccess(comment),
        ...(comment.requestId ? [requestsActions.addRequestComment({
          requestId: comment.requestId,
          commentId: comment._id,
        })]
          : []),
        ...(comment.companyId ? [companiesActions.addCompanyComment({
          companyId: comment.companyId,
          commentId: comment._id,
        })]
          : []),
      ]));
    })
    .catch((error) => {
      dispatch(actions.createCommentFailure());
      message.error(`Failed to create comment: ${getResErrorMsg(error)}`);
      return Promise.reject(error);
    });


/**
* handleCommentUpdate :: (ID, Object) -> Func -> Promise Error _
*/
export const handleCommentUpdate = (commentId, modifier) => dispatch =>
  Promise.resolve(dispatch(actions.updateCommentRequest()))
    .then(() => api.updateComment(commentId, modifier))
    .then(({ comment }) => {
      message.success('Comment updated');
      dispatch(actions.updateCommentSuccess(comment));
    })
    .catch((error) => {
      dispatch(actions.updateCommentFailure());
      message.error(`Failed to update comment: ${getResErrorMsg(error)}`);
      return Promise.reject(error);
    });


/**
 * handleCommentDelete :: (ID, Number) -> Func -> Promise Error _
 */
export const handleCommentDelete = (commentId, notesLength) => dispatch =>
  Promise.resolve(dispatch(actions.deleteCommentRequest()))
    .then(() => api.deleteComment(commentId))
    .then(({ comment }) => {
      message.success('Comment removed');

      return dispatch(batchActions([
        dispatch(actions.deleteCommentSuccess(comment)),
        ...(comment.requestId
          ? [requestsActions.removeRequestComment({
            requestId: comment.requestId,
            commentId: comment._id,
          }),
          requestsActions.setCollapseKey({ arrayLength: notesLength - 1 }),
          ]
          : []),
        ...(comment.companyId
          ? [companiesActions.removeCompanyComment({
            companyId: comment.companyId,
            commentId: comment._id,
          })]
          : []),
      ]));
    })
    .catch((error) => {
      dispatch(actions.deleteCommentFailure());
      message.error(`Failed to delete comment: ${getResErrorMsg(error)}`);
    });



// WEBPACK FOOTER //
// ./src/redux/thunk/comments.js